import React from "react";
import ShotClassContainer from "../ShotClassContainer/ShotClassContainer";
import classes from "./DistributeClass.module.scss";

const DistributeClassList = ({ classData, handleCheckboxChange }) => {
  return (
    <>
      <div className={classes.distributeClassList}>
        {classData?.length > 0 &&
          classData?.map((item) => (
            <div key={item?.ShotClass?.ID}>
              <ShotClassContainer
                type="class"
                data={item?.ShotClass}
                isInfoIconVisible
                isCheckboxVisible
                infoText={`${
                  item?.ShotClass?.PublishedbyMe
                    ? "Published by Me, "
                    : "Published by Others, "
                } Language supported in
                ${item?.ShotClass?.Variants}`}
                handleCheckboxChange={handleCheckboxChange}
                isChecked={item?.ShotClass?.checked}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default DistributeClassList;
